import { type FC } from 'react';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { Glow } from '@/components/ui/Glow/Glow';
import { Picture } from '@/components/ui/Picture/Picture';
import { TopModalGradient } from '@/components/ui/TopModalGradient/TopModalGradient';

import { colorByKind } from './config';

import css from './styles.module.scss';

import starsPng from '/img/modals/stars-1.png';
import starsWebp from '/img/modals/stars-1.webp';

interface SpecContractBgProps {
  kind: SpecContractType | PaidSpecContractType;
}

const SpecContractBg: FC<SpecContractBgProps> = ({ kind }) => {
  return (
    <div className={css.specBg}>
      <Glow
        variant="ellipse"
        aspectRatio="428-280"
        bgColor={colorByKind[kind]}
        className="left-0 top-0 w-full -translate-y-[81.43%] blur-[100px] opacity-50"
      />
      <TopModalGradient />
      <Picture
        className={css.starsBg}
        img={starsPng}
        webp={starsWebp}
        alt="stars"
      />
      <span className={css[`radialGradient--${kind}`]}></span>
    </div>
  );
};

export { SpecContractBg };
